var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "column flex-grow-1" },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: "Airmeet" } },
                [_c("airmeet-settings")],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Clyde" } },
                [_c("clyde-settings")],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "G24 RCE" } },
                [_c("G24RCESettings")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }